import lazyLoad from '@utils/lazyLoad'

const webhookRoutes = [
  // 列表
  {
    path: '/store/webhook',
    exact: true,
    component: lazyLoad(() => import('@views/WebHook'))
  },
  // 新建
  {
    path: '/store/webhook/create',
    exact: true,
    component: lazyLoad(() => import('@views/WebHook/Create')),
    meta: {
      applicationCode: 'f3f9eb1c-5c85-4687-a6ac-3c76045e5b21',
      title: 'webhook新建'
    }
  },
  // 新建
  {
    path: '/store/webhook/edit/:id',
    exact: true,
    component: lazyLoad(() => import('@views/WebHook/Create')),
    meta: {
      applicationCode: 'f3f9eb1c-5c85-4687-a6ac-3c76045e5b21',
      title: 'webhook编辑'
    }
  },
  // 详情
  {
    path: '/store/webhook/detail/:brandId/:id',
    exact: true,
    component: lazyLoad(() => import('@views/WebHook/Detail')),
    meta: {
      applicationCode: 'f3f9eb1c-5c85-4687-a6ac-3c76045e5b21',
      title: 'webhook详情'
    }
  }
]

export default webhookRoutes
